import React from 'react';
import { StyledBackButton, StyledBackButtonText } from './BackButton.styles';
import { useRouter } from 'next/router';
import { TYPES } from '../../../ui-components/typography/PlayText/PlayText';

const BackButton = () => {
    const router = useRouter();

    const handleBack = () => {
        // `state.idx` seems to be the length of the local history stack.
        // It's however undocumented so this may break in the future ¯\_(ツ)_/¯
        if (window.history.state && window.history.state.idx > 0) {
            router.back();
        } else {
            const { titleSlug, episodeSlug, videoId } = router.query;
            router.push({ pathname: router.pathname, query: { titleSlug, episodeSlug, videoId } });
        }
    };

    return (
        <StyledBackButton role="button" aria-label="Stäng videospelaren" onClick={handleBack}>
            <StyledBackButtonText type={TYPES.XLARGE}>Tillbaka</StyledBackButtonText>
        </StyledBackButton>
    );
};

export default BackButton;
